<template>
  <div
    class="hover-btn-root text-center stamp"
    :class="{ incein: isIncein }"
    @touchend="onClick"
    @click="onClick"
  >
    <div class="btn relative">
      <transition-group name="fade" tag="div">
        <img
          :key="1"
          class="img-1"
          :class="{ breathing: shouldBreath }"
          v-show="!active"
          :src="circle1"
        />
        <img
          :key="2"
          class="img-2"
          :class="{ breathing: shouldBreath }"
          v-show="!active"
          :src="circle2"
        />
        <img :key="3" class="img-3" v-show="!active" :src="circle3" />
        <img :key="4" class="img-4" v-show="!active" :src="circle4" />
      </transition-group>
      <transition-group name="fill" tag="div">
        <img :key="5" class="img-5" v-show="active" :src="circleFill" />
      </transition-group>
    </div>
    <div v-show="showHint" class="relative -mt-10" :class="{ 'opacity-0': active }">
      <img class="mx-auto mb-2 triangle" :src="triangle" />
      <p class="instruction text-center" v-html="showHint"></p>
    </div>
  </div>
</template>

<script>
import incein from '@/mixins/incein';
import stampBgm from '@/mixins/stamp-bgm';
import breathing from '@/mixins/breathing';

import circle1 from '../../assets/stamp/circle-1.png';
import circle2 from '../../assets/stamp/circle-2.png';
import circle3 from '../../assets/stamp/circle-3.png';
import circle4 from '../../assets/stamp/circle-4.png';
import circleFill from '../../assets/stamp/circle-fill.png';
import triangle from '../../assets/stamp/triangle-up.png';

import circle1Incein from '../../assets/stamp/incein-l-circle-1.svg';
import circle2Incein from '../../assets/stamp/incein-l-circle-2.svg';
import circle3Incein from '../../assets/stamp/incein-l-circle-3.svg';
import circle4Incein from '../../assets/stamp/incein-l-circle-4.svg';
import circleFillIncein from '../../assets/stamp/incein-circle-fill.svg';
import triangleIncein from '../../assets/stamp/incein-triangle.svg';

export default {
  name: 'HoverButton',
  props: {
    showHint: String,
    hit: Boolean,
    hitDuration: {
      type: Number,
      default: 1200,
    },
  },
  mixins: [breathing, stampBgm, incein],
  mounted() {
    this.hitTimer = null;
  },
  beforeDestroy() {
    if (this.hitTimer) {
      clearTimeout(this.hitTimer);
    }
  },
  data: () => ({
    active: false,
  }),
  watch: {
    hit(nv, ov) {
      if (nv && !ov) {
        this.onHit();
      } else if (ov && !nv) {
        this.active = false;
      }
    },
  },
  methods: {
    onHit() {
      if (this.active) return;

      this.active = true;
      this.hitTimer = setTimeout(() => {
        this.$emit('click');
        this.$emit('active');
      }, this.hitDuration);
    },
    onClick() {
      if (this.active) return;

      this.playPositive();
      setTimeout(() => {
        this.$emit('click');
        this.$emit('active');
      }, 500);
      this.active = true;
      setTimeout(() => {
        this.active = false;
      }, this.hitDuration);
    },
  },
  computed: {
    circle1() {
      return this.isIncein ? circle1Incein : circle1;
    },
    circle2() {
      return this.isIncein ? circle2Incein : circle2;
    },
    circle3() {
      return this.isIncein ? circle3Incein : circle3;
    },
    circle4() {
      return this.isIncein ? circle4Incein : circle4;
    },
    circleFill() {
      return this.isIncein ? circleFillIncein : circleFill;
    },
    triangle() {
      return this.isIncein ? triangleIncein : triangle;
    },
  },
};
</script>

<style scoped lang="scss">
.hover-btn-root {
  &.stamp,
  &.incein {
    .btn {
      max-width: 180px;
      height: 160px;
    }
    .img-1 {
      max-width: 180px;
    }
    .img-2 {
      max-width: 160px;
    }
    .img-3 {
      max-width: 120px;
    }
    .img-4,
    .img-5 {
      max-width: 80px;
    }
    .triangle {
      width: 26px;
    }
  }
  &.stamp {
    .instruction {
      color: rgb(206, 221, 229);
    }
  }
  &.incein {
    .instruction {
      color: #262326;
    }
  }
}
.btn {
  @apply mx-auto;
  max-width: 140px;
  height: 140px;
  & > div {
    @apply relative flex mx-auto justify-center items-center;
    width: 140px;
    bottom: 20px;
    transform: scale(1.3);
    img {
      @apply absolute;
    }
  }
}
.fade-enter-active {
  transition: all 0.5s ease-in;
}
.fade-leave-active {
  transition: all 1.2s ease-out;
}
.fade-enter-to,
.fade-leave {
  transform: scale(1) rotate(0);
}
.fade-enter,
.fade-leave-to {
  transform: scale(0) rotate(-200deg);
  &.img-3 {
    transform: scale(0);
  }
}

.fill-enter-active {
  transition: all 0.5s ease-out;
}
.fill-leave-active {
  transition: all 0.3s ease-out;
}
.fill-enter-to,
.fill-leave {
  transform: scale(1);
}
.fill-enter,
.fill-leave-to {
  transform: scale(0);
}
.img-3 {
  transform: scale(1.1);
}
.instruction {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.25;
  color: #540deb;
}
</style>
